@if (errorService.serverError(); as serverError) {
	<error-page [status]="serverError" (logout)="logout()"></error-page>
} @else {
	<div class="app" [class]="pageName()">
		<div class="app__container">
			<app-shell-nav
				class="hide-mobile"
				[items]="desktopMenuPoints()"
				[environment]="environment"
				[apps]="appNavMenuPoints()"
				[activeApp]="activeApp"
				[currentUrl]="currentUrl()"
				[navTranslations]="{
					beta: ('general.beta' | translate),
					apps: ('general.apps' | translate),
				}"
				(callbackEvent)="navCallback($event)"
			></app-shell-nav>
			<app-shell-mobile-nav
				class="hide-desktop"
				[items]="mobileMenuPoints()"
				[environment]="environment"
				[apps]="appNavMenuPoints()"
				[currentUrl]="currentUrl()"
				(callbackEvent)="navCallback($event)"
				[navTranslations]="{
					beta: ('general.beta' | translate),
					apps: ('general.apps' | translate),
				}"
			></app-shell-mobile-nav>

			<div class="app__page">
				<router-outlet></router-outlet>
				@if (error()) {
					<ui-overlay
						(closeOverlay)="onClose()"
						[showCloseButton]="true"
						[header]="error().type + '.header' | lowercase | translate"
					>
						<ui-error-content [error]="error()" (closed)="onClose()"></ui-error-content>
					</ui-overlay>
				}
			</div>
		</div>
	</div>

	@if (helpOpen()) {
		<ui-overlay [header]="'help.title' | translate" (closeOverlay)="onCloseHelp()">
			<manage-help-content
				[environment]="environment"
				(closed)="onCloseHelp()"
			></manage-help-content>
		</ui-overlay>
	}

	<toast-container></toast-container>
	<cookie-overlay></cookie-overlay>
}
